import { MoreVert, PersonPin, SettingsSuggest } from "@mui/icons-material";
import { Chip, IconButton, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import React, { useState } from "react";
import { globalbackgroundProposal, globalColorTextProposal } from "../../../shared/utils";
import { globalTranslateStatusReadJust } from "./Translate";

interface TableReadJustProps {
	rows: any[];
	isLoading?: boolean;
	canUpdate?: boolean;
	onEdit?: (row: any) => void;
}

const DateDisplay: React.FC<{ date?: string; formatStr: string }> = ({ date, formatStr }) => {
	return (
		<Typography variant="subtitle2" color={"#959595"} fontWeight={"normal"} textAlign={"left"}>
			{date ? `${format(new Date(date), formatStr, { locale: ptBR })}` : "N/A"}
		</Typography>
	);
};

const StatusChip: React.FC<{ status: string; label: string; icon?: React.ReactElement; transparent?: boolean }> = ({ status, label, icon, transparent }) => {
	return (
		<Chip
			size="medium"
			label={label}
			icon={icon}
			variant={transparent ? "outlined" : "filled"}
			sx={{
				color: globalColorTextProposal(status),
				fontWeight: "500",
				background: globalbackgroundProposal(status),
				border: "0.5px solid lightgray",
			}}
		/>
	);
};

export const TableReadjust: React.FC<TableReadJustProps> = ({ rows, isLoading, canUpdate = true, onEdit }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [selectedRow, setSelectedRow] = useState<any>(null);

	const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>, row: any) => {
		setAnchorEl(event.currentTarget);
		setSelectedRow(row);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleEdit = () => {
		if (!canUpdate) return;
		if (selectedRow) {
			onEdit?.(selectedRow);
		}
		// Depois feche o menu
		handleMenuClose();
	};


	return (
		<>
			<TableContainer component={Paper} variant="outlined" sx={{ marginTop: 1, width: "auto", padding: 1, ml: 1, border: "none" }}>
				<Table aria-label="a dense table" >
					<TableHead>
						<TableRow>
							<TableCell colSpan={12} sx={{ padding: "0px" }}>
								<Typography variant="h6" component="h1">
									Lista de Reajustes
								</Typography>
							</TableCell>
						</TableRow>
						<TableRow sx={{ background: "#f5fbfd" }}>
							<TableCell>Cadastro</TableCell>
							<TableCell>Referência</TableCell>
							<TableCell sx={{ textAlign: "center" }}>IPCA</TableCell>
							<TableCell sx={{ textAlign: "center" }}>INCC</TableCell>
							<TableCell sx={{ textAlign: "center" }}>IPGM</TableCell>
							<TableCell>Tipo Cadastro</TableCell>
							<TableCell>#</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{!isLoading &&
							rows.map((row) => (
								<TableRow key={row.reference} hover>
									<TableCell>
										<DateDisplay date={row.createdAt} formatStr="dd/MM/yyyy" />
										<DateDisplay date={row.createdAt} formatStr="HH:mm:ss" />
									</TableCell>
									<TableCell>
										<DateDisplay date={row.reference} formatStr="MM/yyyy" />
									</TableCell>
									{["ipca", "incc", "igpm"].map((index) => (
										<TableCell key={index} sx={{ textAlign: "center" }}>
											<Typography variant="body2" color={"#5c5858"} sx={{ fontWeight: "normal" }}>
												Acumulado no ano
											</Typography>
											<Typography variant="body1" sx={{ fontWeight: "500" }}>
												{row[index]}%
											</Typography>
										</TableCell>
									))}
									<TableCell>
										<StatusChip
											status={row.created_from}
											transparent
											label={globalTranslateStatusReadJust(row.created_from)}
											icon={row.created_from === "empty" ? <PersonPin color="action" /> : <SettingsSuggest color="action" />}
										/>
									</TableCell>

									<TableCell sx={{ textAlign: "center" }}>
										<IconButton size="small" onClick={(event) => handleMenuOpen(event, row)} disabled={!canUpdate}>
											<MoreVert />
										</IconButton>
										<Menu
											anchorEl={anchorEl}
											open={Boolean(anchorEl)}
											onClose={handleMenuClose}
											anchorOrigin={{
												vertical: "top",
												horizontal: "right",
											}}
											transformOrigin={{
												vertical: "top",
												horizontal: "right",
											}}
										>
											{canUpdate && <MenuItem onClick={handleEdit}>Editar</MenuItem>}
										</Menu>
									</TableCell>
								</TableRow>
							))}
					</TableBody>
				</Table>
			</TableContainer>

		</>
	);
};
